export { default as TextInput, type TextInputProps } from './TextInput';
